import { useSystem } from '@/context/SystemProvider'
import { Box, Button, Flex, Popover, PopoverBody, PopoverContent, PopoverTrigger, Text } from '@chakra-ui/react'
import { useTranslation } from 'next-i18next/pages'

export const NetworkStatus = () => {
  const { t } = useTranslation()
  const isUpToDate = useSystem((state) => state.isUpToDate)

  return (
    <Flex gap={1} alignItems={'center'} justifyContent={'center'} rounded={'full'}>
      <Flex
        display={{ base: 'flex', sm: 'none', lg: 'flex' }}
        mr={'px'}
        w={5}
        h={5}
        rounded={'full'}
        bg={isUpToDate ? 'rgba(104, 242, 118, 0.12)' : 'rgb(255, 125, 125, 0.12)'}
        alignItems={'center'}
        justifyContent={'center'}
      >
        <Box w={2} h={2} rounded={'full'} bg={isUpToDate ? 'brand.green' : 'brand.error'} />
      </Flex>
      <Text display={{ base: 'block', sm: 'none', lg: 'block' }} lineHeight={'1'} fontSize={'xs'} fontWeight={700}>
        {t('common.network')}
      </Text>
      <Text display={{ base: 'block', sm: 'none', lg: 'block' }} lineHeight={'1'} fontSize={'xs'} color={'ninja.200'}>
        {isUpToDate ? t('common.up-to-date') : t('common.high-latency')}
      </Text>
      <Popover strategy={'fixed'} placement={'right'}>
        <PopoverTrigger>
          <Button h={10} variant={'unstyled'} display={{ base: 'none', sm: 'flex', lg: 'none' }}>
            <Flex
              rounded={'full'}
              alignItems={'center'}
              justifyContent={'center'}
              bg={isUpToDate ? 'rgba(104, 242, 118, 0.12)' : 'rgb(255, 125, 125, 0.12)'}
              width={5}
              h={5}
            >
              <Box w={2} h={2} rounded={'full'} bg={isUpToDate ? 'brand.green' : 'brand.error'} />
            </Flex>
          </Button>
        </PopoverTrigger>
        <PopoverContent
          bg={'ninja.700'}
          border={'none'}
          w={'max-content'}
          rounded={'2xl'}
          boxShadow={'0px 4px 32px 0px rgba(0, 0, 0, 0.24);'}
        >
          <PopoverBody py={3} px={4}>
            <Text lineHeight={'1'} fontSize={'xs'} fontWeight={700}>
              {t('common.network')}
            </Text>
            <Text lineHeight={'1'} fontSize={'xs'} color={'ninja.200'}>
              {isUpToDate ? t('common.up-to-date') : t('common.high-latency')}
            </Text>
          </PopoverBody>
        </PopoverContent>
      </Popover>
    </Flex>
  )
}
